import DialogName from '@/shared/types/dialogName.enum';

import UpdateHandlers from '../../../../types/updateHandlers.type';

type Args = UpdateHandlers<unknown>;

const useHandleAddTile = ({ onUpdateDialogState }: Args) => {
  const handleOpenAddTileDialog = () => {
    onUpdateDialogState(DialogName.AddTile, { open: true });
  };

  return {
    trigger: handleOpenAddTileDialog,
  };
};

export default useHandleAddTile;
